import { FeatureSrcMap } from './constants/feature';
import { FULLSCREEN_IFRAME_CSS } from './constants/iframe';
import { FeatureUnboxingEmbedderMessages } from './constants/messages';
import { isAcceptanceTest, isQa } from './utils/env';
import { getIframeDomain } from './utils/iframeUtils';
// @ts-expect-error Not Typed
import { fetchTreatment } from './utils/laboratory';
import { getLocaleFromDomain } from './utils/langUtils';
export default class FeatureUnboxingEmbedder {
  constructor(featureName, experimentKey, exprimentCTAContainerId, productised = false) {
    this.iframeId = 'feature-unboxing-embedder-iframe';
    this.isVariant = false;
    this.isActiveExperiment = false;
    this.featureName = featureName;
    this.experimentKey = experimentKey;
    this.exprimentCTAContainerId = exprimentCTAContainerId;
    this.isVariant = productised;
    this.injectStyles();
    this.iframe = this.createHiddenIframe();
    this.setupPostMessageListener();
  }
  getMessageHandlers() {
    return {
      [FeatureUnboxingEmbedderMessages.CloseIframe]: event => {
        if (event.origin === getIframeDomain(this.iframe)) {
          this.hideIframe();
        }
      },
      [FeatureUnboxingEmbedderMessages.FullscreenIframe]: event => {
        if (event.origin === window.parent.origin) {
          this.showIframe();
        }
      },
      [FeatureUnboxingEmbedderMessages.ParentLoaded]: event => {
        if (event.origin === window.parent.origin) {
          void this.handleParentLoaded({
            onComplete: () => this.showExperimentContainer()
          });
        }
      },
      [FeatureUnboxingEmbedderMessages.RedirectTo]: event => {
        if (event.origin === this.getRedirectDomain(event.data.value)) {
          this.redirectTo(event.data.value);
        }
      }
    };
  }
  setupPostMessageListener() {
    window.addEventListener('message', event => {
      const messageType = event.data.action || event.data;
      if (messageType in this.getMessageHandlers()) {
        const handler = this.getMessageHandlers()[messageType];
        handler(event);
      }
    });
  }
  injectStyles() {
    const style = document.createElement('style');
    style.textContent = FULLSCREEN_IFRAME_CSS;
    document.head.appendChild(style);
  }
  createHiddenIframe() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.id = this.iframeId;
    iframe.allow = 'fullscreen';
    iframe.src = FeatureSrcMap[this.featureName];
    document.body.appendChild(iframe);
    return iframe;
  }
  redirectTo(url) {
    window.location.href = url;
  }
  getUUID() {
    return window.__utAnonId;
  }
  setQueryParams() {
    const baseUrl = this.iframe.src.split('?')[0];
    const existingParams = this.iframe.src.split('?')[1] || '';
    const params = new URLSearchParams(existingParams);
    const language = getLocaleFromDomain();
    params.set('lang', language);
    if (this.uuid) {
      params.set('uuid', this.uuid);
    }
    this.iframe.src = `${baseUrl}?${params.toString()}`;
  }
  showIframe() {
    if (this.animationTimeoutId) {
      clearTimeout(this.animationTimeoutId);
    }
    this.iframe.classList.add('fullscreen-iframe');
    this.iframe.style.display = 'block';
    this.iframe.classList.add('expand-fade-in');
    this.animationTimeoutId = window.setTimeout(() => {
      this.iframe.classList.remove('expand-fade-in');
      this.animationTimeoutId = undefined;
    }, 500);
    document.body.classList.add('full-screen-iframe-body');
  }
  hideIframe() {
    if (this.animationTimeoutId) {
      clearTimeout(this.animationTimeoutId);
    }
    this.iframe.classList.add('shrink-fade-out');
    this.animationTimeoutId = window.setTimeout(() => {
      this.iframe.style.display = 'none';
      this.iframe.classList.remove('shrink-fade-out');
      this.iframe.classList.remove('fullscreen-iframe');
      document.body.classList.remove('full-screen-iframe-body');
      this.animationTimeoutId = undefined;
    }, 500);
  }
  getRedirectDomain(redirectUrl) {
    const url = new URL(redirectUrl);
    return url.origin;
  }
  async handleParentLoaded({
    onComplete
  }) {
    this.uuid = this.getUUID();
    this.setQueryParams();
    if (!this.isVariant && !isAcceptanceTest()) {
      await fetchTreatment(window, document, 'script', `https://js.hubspot${isQa() ? 'qa' : ''}.com/lab-js/v1/standalone.js`, treatment => {
        var _treatment$this$exper, _treatment$this$exper2;
        this.isActiveExperiment = (_treatment$this$exper = treatment[this.experimentKey]) === null || _treatment$this$exper === void 0 || (_treatment$this$exper = _treatment$this$exper.status) === null || _treatment$this$exper === void 0 ? void 0 : _treatment$this$exper.isActive;
        if (((_treatment$this$exper2 = treatment[this.experimentKey]) === null || _treatment$this$exper2 === void 0 || (_treatment$this$exper2 = _treatment$this$exper2.parameters) === null || _treatment$this$exper2 === void 0 ? void 0 : _treatment$this$exper2.group) === 'variation') {
          this.isVariant = true;
        }
        onComplete();
      }, [this.experimentKey], {
        other: `${this.uuid}`
      });
    } else {
      onComplete();
    }
  }
  showExperimentContainer() {
    const container = document.getElementById(this.exprimentCTAContainerId);
    if (!container) return;
    this.updateCTA(container);
    container.style.display = 'block';
  }
  updateCTA(container) {
    const links = container.getElementsByTagName('a');
    for (const link of Array.from(links)) {
      if (link.classList.value.includes('-primary')) {
        if (this.isVariant) {
          link.href = '';
          link.onclick = event => {
            event.preventDefault();
            this.showIframe();
          };
        } else if (this.isActiveExperiment) {
          link.href = `${link.href}&external-experiment-parameter=${this.experimentKey}-group-control`;
        }
        break;
      }
    }
  }
}